// onMarsFaqExtended.ts
export type ExtendedFaq = {
  id: string;
  section: string;
  question: string;
  answer: string;
  tags: string[];
};

export const onMarsFaqExtended: ExtendedFaq[] = [
  {
    "id": "faqx-001",
    "section": "rules",
    "question": "Czy mogę wykonać akcję z drugiej strony planszy?",
    "answer": "Nie. Akcje główne zależą od aktualnej strefy gracza.",
    "tags": [
      "faq"
    ]
  },
  {
    "id": "faqx-002",
    "section": "rules",
    "question": "Czy akcję wykonawczą mogę wykonać przed akcją główną?",
    "answer": "Tak, ale maksymalnie jedną akcję wykonawczą na turę.",
    "tags": [
      "faq"
    ]
  },
  {
    "id": "faqx-003",
    "section": "rules",
    "question": "Czy mogę wykonać dwie akcje wykonawcze?",
    "answer": "Nie. Limit wynosi jedną na turę.",
    "tags": [
      "faq"
    ]
  },
  {
    "id": "faqx-004",
    "section": "rules",
    "question": "Czy świeży kryształ mogę od razu wydać?",
    "answer": "Nie. Staje się dostępny na początku następnej tury.",
    "tags": [
      "faq"
    ]
  },
  {
    "id": "faqx-005",
    "section": "rules",
    "question": "Czy kolonista wraca po wykonaniu akcji?",
    "answer": "Nie automatycznie. Potrzebny jest odpowiedni efekt.",
    "tags": [
      "faq"
    ]
  },
  {
    "id": "faqx-006",
    "section": "rules",
    "question": "Czy mogę użyć kolonisty z obszaru pracy?",
    "answer": "Nie. Dostępni są koloniści w kwaterach.",
    "tags": [
      "faq"
    ]
  },
  {
    "id": "faqx-007",
    "section": "rules",
    "question": "Czy zajęte pole akcji blokuje akcję?",
    "answer": "Zwykle nie, ale może zwiększać wymaganą siłę akcji.",
    "tags": [
      "faq"
    ]
  },
  {
    "id": "faqx-008",
    "section": "rules",
    "question": "Czy łazik wyznacza zasięg budowy?",
    "answer": "Nie. Zasięg budowy wyznacza własny bot.",
    "tags": [
      "faq"
    ]
  },
  {
    "id": "faqx-009",
    "section": "rules",
    "question": "Czy mogę budować w zasięgu bota przeciwnika?",
    "answer": "Nie w ramach standardowej budowy.",
    "tags": [
      "faq"
    ]
  },
  {
    "id": "faqx-010",
    "section": "rules",
    "question": "Czy osobny budynek tego samego typu wymaga technologii?",
    "answer": "Nie, jeśli nie tworzy ani nie powiększa kompleksu.",
    "tags": [
      "faq"
    ]
  },
  {
    "id": "faqx-011",
    "section": "rules",
    "question": "Kiedy potrzebuję technologii do budowy?",
    "answer": "Gdy budowa tworzy albo powiększa kompleks.",
    "tags": [
      "faq"
    ]
  },
  {
    "id": "faqx-012",
    "section": "rules",
    "question": "Czy mogę użyć technologii przeciwnika?",
    "answer": "Tak. Rozpatrz premię jej właściciela.",
    "tags": [
      "faq"
    ]
  },
  {
    "id": "faqx-013",
    "section": "rules",
    "question": "Czy budynek zaawansowany nadal należy do kompleksu?",
    "answer": "Tak, zachowuje podstawowy typ dla potrzeb kompleksu.",
    "tags": [
      "faq"
    ]
  },
  {
    "id": "faqx-014",
    "section": "rules",
    "question": "Czy schronienie działa jak zwykły budynek LSS?",
    "answer": "Nie. Schronienia mają odrębne reguły.",
    "tags": [
      "faq"
    ]
  },
  {
    "id": "faqx-015",
    "section": "rules",
    "question": "Czy każda budowa LSS daje nagrodę?",
    "answer": "Nie. Zależy to od pozycji znacznika względem poziomu kolonii.",
    "tags": [
      "faq"
    ]
  },
  {
    "id": "faqx-016",
    "section": "rules",
    "question": "Czy kopalnia przesuwa tor LSS?",
    "answer": "Nie ma osobnego toru LSS kopalni.",
    "tags": [
      "faq"
    ]
  },
  {
    "id": "faqx-017",
    "section": "rules",
    "question": "Co sprawdzić po budowie LSS?",
    "answer": "Przesuń znacznik, rozpatrz premię i sprawdź wzrost kolonii.",
    "tags": [
      "faq"
    ]
  },
  {
    "id": "faqx-018",
    "section": "rules",
    "question": "Czy poziom kolonii może wzrosnąć kilka razy?",
    "answer": "Rozpatruj każdy wzrost osobno i wykonuj pełną aktualizację.",
    "tags": [
      "faq"
    ]
  },
  {
    "id": "faqx-019",
    "section": "rules",
    "question": "Co aktualizuję po wzroście kolonii?",
    "answer": "Technologie, magazyn, statki, projekty, wahadłowiec, misje i ewentualną punktację postępu.",
    "tags": [
      "faq"
    ]
  },
  {
    "id": "faqx-020",
    "section": "rules",
    "question": "Czy technologia jest jednorazowa?",
    "answer": "Nie. Pozostaje aktywna przez całą grę.",
    "tags": [
      "faq"
    ]
  },
  {
    "id": "faqx-021",
    "section": "rules",
    "question": "Czy przeciwnik może odmówić użycia technologii?",
    "answer": "Nie, jeżeli zasady pozwalają na jej użycie.",
    "tags": [
      "faq"
    ]
  },
  {
    "id": "faqx-022",
    "section": "rules",
    "question": "Czy od razu rozwijam nowo pozyskaną technologię?",
    "answer": "Nie. Pozyskanie i rozwój są odrębnymi efektami.",
    "tags": [
      "faq"
    ]
  },
  {
    "id": "faqx-023",
    "section": "rules",
    "question": "Czy premia projektu oznacza, że jest zbudowany?",
    "answer": "Nie. Projekt pozostaje niezbudowany do chwili ulepszenia budynku.",
    "tags": [
      "faq"
    ]
  },
  {
    "id": "faqx-024",
    "section": "rules",
    "question": "Czy mogę mieć kilka niezbudowanych projektów?",
    "answer": "Tak, ale zwiększa to ryzyko punktów ujemnych.",
    "tags": [
      "faq"
    ]
  },
  {
    "id": "faqx-025",
    "section": "rules",
    "question": "Czy naukowiec musi stać w moim budynku?",
    "answer": "Nie zawsze. Liczy się zgodność specjalizacji i legalne umieszczenie.",
    "tags": [
      "faq"
    ]
  },
  {
    "id": "faqx-026",
    "section": "rules",
    "question": "Za czyje budynki punktuje naukowiec?",
    "answer": "Za wszystkie pasujące budynki zaawansowane na mapie.",
    "tags": [
      "faq"
    ]
  },
  {
    "id": "faqx-027",
    "section": "rules",
    "question": "Czy niewykonany kontrakt daje zero?",
    "answer": "Nie. Jest rozliczany ujemnie.",
    "tags": [
      "faq"
    ]
  },
  {
    "id": "faqx-028",
    "section": "rules",
    "question": "Czy zasób na kontrakcie zajmuje magazyn?",
    "answer": "Nie, ale nie można go później odzyskać.",
    "tags": [
      "faq"
    ]
  },
  {
    "id": "faqx-029",
    "section": "rules",
    "question": "Czy minerał zastępuje zasób w kontrakcie?",
    "answer": "Nie.",
    "tags": [
      "faq"
    ]
  },
  {
    "id": "faqx-030",
    "section": "rules",
    "question": "Czy mogę zakończyć ruch na odkryciu bez opłacenia kosztu?",
    "answer": "Nie.",
    "tags": [
      "faq"
    ]
  },
  {
    "id": "faqx-031",
    "section": "rules",
    "question": "Czy wahadłowiec jest obowiązkowy?",
    "answer": "Nie. Możesz zostać albo użyć prywatnego transportu.",
    "tags": [
      "faq"
    ]
  },
  {
    "id": "faqx-032",
    "section": "rules",
    "question": "Czy mogę użyć prywatnego statku bez lotu wahadłowca?",
    "answer": "Tak, jeśli spełniasz warunki.",
    "tags": [
      "faq"
    ]
  },
  {
    "id": "faqx-033",
    "section": "rules",
    "question": "Czy mogę zostać po jednej stronie wiele rund?",
    "answer": "Tak, ale masz dostęp tylko do akcji tej strony.",
    "tags": [
      "faq"
    ]
  },
  {
    "id": "faqx-034",
    "section": "rules",
    "question": "Czy kilku graczy może pracować nad misją?",
    "answer": "Tak. Misje są wspólne.",
    "tags": [
      "faq"
    ]
  },
  {
    "id": "faqx-035",
    "section": "rules",
    "question": "Czy kryształ z misji mogę wydać od razu?",
    "answer": "Nie. Jest świeżo zdobytym kryształem.",
    "tags": [
      "faq"
    ]
  },
  {
    "id": "faqx-036",
    "section": "rules",
    "question": "Czy ukończenie misji kończy grę natychmiast?",
    "answer": "Nie. Uruchamia finałową sekwencję.",
    "tags": [
      "faq"
    ]
  },
  {
    "id": "faqx-037",
    "section": "rules",
    "question": "Czy w ostatniej rundzie jest faza wahadłowca?",
    "answer": "Nie.",
    "tags": [
      "faq"
    ]
  },
  {
    "id": "faqx-038",
    "section": "rules",
    "question": "Czy niezbudowany projekt punktuje zero?",
    "answer": "Nie. Może dać punkty ujemne.",
    "tags": [
      "faq"
    ]
  },
  {
    "id": "faqx-039",
    "section": "rules",
    "question": "Czy naukowiec liczy budynki przeciwników?",
    "answer": "Tak, jeżeli pasują do jego specjalizacji.",
    "tags": [
      "faq"
    ]
  },
  {
    "id": "faqx-040",
    "section": "rules",
    "question": "Czy kontrakt można odrzucić bez kary?",
    "answer": "Nie traktuj go jako zwykłej karty do odrzucenia.",
    "tags": [
      "faq"
    ]
  },
  {
    "id": "faqx-041",
    "section": "rules",
    "question": "Czy cel prywatny można zrealizować w dowolnym momencie?",
    "answer": "Nie. Zrealizuj go w dozwolonym oknie swojej tury.",
    "tags": [
      "faq"
    ]
  },
  {
    "id": "faqx-042",
    "section": "rules",
    "question": "Czy można zrealizować dwa cele prywatne?",
    "answer": "Nie. Maksymalnie jeden w całej grze.",
    "tags": [
      "faq"
    ]
  },
  {
    "id": "faqx-043",
    "section": "rules",
    "question": "Czy niewykorzystany cel można zamienić na kryształ?",
    "answer": "Tak, zgodnie z zasadą użycia karty jako kryształu.",
    "tags": [
      "faq"
    ]
  },
  {
    "id": "faqx-044",
    "section": "rules",
    "question": "Czy mogę dokupić ruch łazika?",
    "answer": "Tak, jeżeli pozwala na to efekt i masz dostępne kryształy.",
    "tags": [
      "faq"
    ]
  },
  {
    "id": "faqx-045",
    "section": "rules",
    "question": "Czy statek użyty do podróży nadal punktuje?",
    "answer": "Zależy od jego końcowego położenia.",
    "tags": [
      "faq"
    ]
  },
  {
    "id": "faqx-046",
    "section": "rules",
    "question": "Czy gracze po obu stronach wykonują tury w jednej kolejności?",
    "answer": "Każda strona ma własne pola kolejności; stosuj aktualną kolejność po stronie gracza.",
    "tags": [
      "faq"
    ]
  },
  {
    "id": "faqx-047",
    "section": "rules",
    "question": "Czy można uzupełnić magazyn orbitalny po każdym pobraniu?",
    "answer": "Nie, chyba że konkretny efekt tak stanowi.",
    "tags": [
      "faq"
    ]
  },
  {
    "id": "faqx-048",
    "section": "rules",
    "question": "Czy projekt można zbudować bez właściwego budynku?",
    "answer": "Nie. Potrzebujesz zgodnego legalnego budynku do ulepszenia.",
    "tags": [
      "faq"
    ]
  },
  {
    "id": "faqx-049",
    "section": "rules",
    "question": "Czy łazik może zastąpić bota przy ulepszaniu?",
    "answer": "Nie.",
    "tags": [
      "faq"
    ]
  },
  {
    "id": "faqx-050",
    "section": "rules",
    "question": "Czy akcja wykonawcza zastępuje akcję główną?",
    "answer": "Nie. Jest dodatkowa.",
    "tags": [
      "faq"
    ]
  },
  {
    "id": "faqx-051",
    "section": "travel",
    "question": "Których kolonistów odzyskuję podczas podróży?",
    "answer": "Ze strony, którą opuszczasz, oraz ze strefy pracy. Na powierzchnię: pola akcji orbity. Na orbitę: pola akcji kolonii. Nigdy ze strony docelowej.",
    "tags": [
      "faq",
      "podróż",
      "koloniści"
    ]
  }
];

export function searchOnMarsFaq(query: string): ExtendedFaq[] {
  const q = query.trim().toLocaleLowerCase("pl-PL");
  if (!q) return onMarsFaqExtended;
  return onMarsFaqExtended.filter((entry) =>
    [entry.section, entry.question, entry.answer, ...entry.tags]
      .join(" ")
      .toLocaleLowerCase("pl-PL")
      .includes(q),
  );
}
